import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-card-five-comments',
  templateUrl: './card-five-comments.component.html',
  styleUrls: ['./card-five-comments.component.scss']
})
export class CardFiveCommentsComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
